module.exports = __webpack_public_path__ + "img/about-prize-bg-shape@dt.b93a457.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-prize-bg-shape@dt.svg
// module id = Fdw4
// module chunks = 2